/* unplugin-vue-components disabled */import script from "./OrgChatApps.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgChatApps.vue?vue&type=script&setup=true&lang=ts"

import "./OrgChatApps.vue?vue&type=style&index=0&id=073f2240&lang=stylus"

const __exports__ = script;

export default __exports__